export type ProgressReportDecision = {
  nextReportedSeconds: number;
  report: boolean;
};

export function evaluateProgressReport(
  lastReportedSeconds: number,
  positionSeconds: number,
  intervalSeconds = 10,
): ProgressReportDecision {
  const last = Number.isFinite(lastReportedSeconds)
    ? Math.max(0, lastReportedSeconds)
    : 0;
  if (!Number.isFinite(positionSeconds)) {
    return { nextReportedSeconds: last, report: false };
  }
  const position = Math.max(0, positionSeconds);
  const interval = Number.isFinite(intervalSeconds)
    ? Math.max(0, intervalSeconds)
    : 10;
  if (position - last < interval) {
    return { nextReportedSeconds: last, report: false };
  }
  return { nextReportedSeconds: position, report: true };
}
